import { Button, FlexWrapper, FontIcon, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import { __ } from '../../../../translations';
import { PaymentFailedPopupProps } from '../../types/iGamification';
import { Modal } from '../../../../components/ui/Modal';

const PaymentFailedPopup = ({ isOpen, closePopup, handleUpdatePayment }: PaymentFailedPopupProps) => {
    return (
        <Modal useFlexLayout={false} open={isOpen} onOpenChange={closePopup} closePlacement="end" widthSet="medium">
            <FlexWrapper flexDirection="column" gap={{ default: '2x', md: '3x' }}>
                <FontIcon name="info" size="size60" md="size60" />
                <Text as="h3" variant="h3" margin="0" size={{ default: '22', md: '28' }}>
                    {__('gamification_payment_failure_popup_title')}
                </Text>
                <Text as="p" margin="0" color="gray" alignment="center">
                    {__(`gamification_payment_failure_popup_desc`)}
                </Text>
                <FlexWrapper flexDirection="row" gap={{ default: '2x', md: '3x' }} paddingTop={{ default: '2x' }}>
                    <FlexChild alignSelf="center" placement={'center'}>
                        <Button onClick={handleUpdatePayment} fullWidth>
                            {__('gamification_payment_failure_popup_update_payment')}
                        </Button>
                    </FlexChild>
                </FlexWrapper>
            </FlexWrapper>
        </Modal>
    );
};

export default PaymentFailedPopup;
